import React from 'react';
// @ts-expect-error untyped-import
import { PurchaseIcon } from '../Spots/Icons/PurchaseIcon';
import {
  SpinnerContainer,
  Spinner as SpinnerDiv,
  SpinnerLoader,
} from './StyledComponents';

type SpinnerProps = { icon: boolean | React.ReactElement };
const Spinner = ({ icon: Icon }: SpinnerProps): JSX.Element => {
  return (
    <SpinnerDiv>
      <SpinnerContainer data-testid="spinner-icon">
        {Icon && <PurchaseIcon />}
      </SpinnerContainer>
      <SpinnerLoader />
    </SpinnerDiv>
  );
};

export default Spinner;
